import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';

import QRExampleLarge from '~/assets/icons/EXAMPLE_QR_API.png';
import ContentContainer from '~/components/atoms/content-container/ContentContainer';
import { COLORS } from '~/styles/colors';

interface ExampleApiProps {
  title: string;
  params: Record<string, any>; // Adjust the type as needed, if you know the shape of params
}

export const ExampleApi = ({ title, params }: ExampleApiProps) => {
  const { t } = useTranslation();

  return (
    <ContentContainer
      display="flex"
      justifyContent="space-between"
      title={title}
      resetPadding
      containerStyles={{ mb: 3, p: 2 }}
    >
      <Box sx={{ width: '100%', mt: 2 }}>
        <Typography>{t('api:code:titleMethod')}</Typography>
        <Box sx={{ backgroundColor: COLORS.purpleBG, p: 2, mt: 1, mb: 2 }}>
          <Typography sx={{ color: COLORS.black06 }}>POST</Typography>
        </Box>
        <Typography>{t('api:code:titleUrl')}</Typography>
        <Box sx={{ backgroundColor: COLORS.purpleBG, p: 2, mt: 1, mb: 2 }}>
          <Typography sx={{ color: COLORS.black06 }}>https://api.qr-gen.com/v1/create</Typography>
        </Box>
        <Typography>{t('api:code:titleParameters')}</Typography>
        <Box sx={{ backgroundColor: COLORS.purpleBG, p: 2, mt: 1, mb: 1 }}>
          <Typography fontSize={14} sx={{ color: COLORS.black06 }}>
            <pre>{JSON.stringify(params, null, 2)}</pre>
          </Typography>
        </Box>
        <Typography fontSize={12} sx={{ color: COLORS.black06, mb: 2 }}>
          {t('api:code:paramDescription')}
        </Typography>
        <Typography>{t('api:code:outcome')}</Typography>
        <Box sx={{ pt: 2 }}>
          <img style={{ width: 250, height: 250 }} src={QRExampleLarge} />
        </Box>
      </Box>
    </ContentContainer>
  );
};
